import { DiceComponent } from '@dice/app/components/view/dice.component';
import { Ng2StateDeclaration } from '@uirouter/angular';

export const DICE_STATE: Ng2StateDeclaration = {
  abstract: true,
  name: 'dice',
  component: DiceComponent,
};
